export var MarkerSelectValue;
(function (MarkerSelectValue) {
    MarkerSelectValue["INFORMATIVE"] = "INFORMATIVE";
    MarkerSelectValue["POSITIVE"] = "POSITIVE";
    MarkerSelectValue["WARNING"] = "WARNING";
    MarkerSelectValue["NEGATIVE"] = "NEGATIVE";
    MarkerSelectValue["NEUTRAL"] = "NEUTRAL";
})(MarkerSelectValue || (MarkerSelectValue = {}));
